/**
 * @prettier
 */

import React from 'react';
import FeatureFlags from '../../../../../util/featureFlags';
import BreadCrumbs from '../BreadCrumbs/BreadCrumbs';
import SamplePreview from '../SamplePreview/SamplePreview';
import Layout from '../Layout/Layout';
import { STEPS } from '../constants/steps';
import MultiSample from '../MultiSample/MultiSample';
import { useMobileCheck } from '../util/hooks';
import styles from './styles.module.less';

const MultiUploadHelp = ({
  form,
  goToStep,
  step,
  breadcrumbSteps,
  colors,
  sampleNotCustomizable,
  enablePhotoUpload,
  template,
  updateForm,
  skuData,
  cardSuiteDetails,
  isMagnet,
  isMulti,
  setMultiPreviewState,
  multiPreviewState,
  cardSuiteUUIDList,
  cardSuiteDetailsSet,
  multiHasCustomizableCard,
}) => {
  const isMobile = useMobileCheck();

  const isPhotoValid = form.customizations.photo.valid;

  const previewElement = (
    <SamplePreview
      hideColorPicker={sampleNotCustomizable}
      colors={colors}
      template={template}
      form={form}
      updateForm={updateForm}
      sampleNotCustomizable={sampleNotCustomizable}
      skuData={skuData}
      cardSuiteDetails={cardSuiteDetails}
      isMagnet={isMagnet}
      isMulti={isMulti}
      enableHoverActions={enablePhotoUpload}
      setMultiPreviewState={setMultiPreviewState}
      multiPreviewState={multiPreviewState}
      cardSuiteUUIDList={cardSuiteUUIDList}
      cardSuiteDetailsSet={cardSuiteDetailsSet}
    />
  );

  let text = <Layout.Text>Double-check each design looks good to you.</Layout.Text>;
  let tips = (
    <ul className={styles.photoUploadTips}>
      <li>Use different photos for each design if you&#39;d like.</li>
      <li>Crop any photo to make it fit better.</li>
      <li>Avoid covering your faces with text.</li>
    </ul>
  );
  let photoActions = null;
  let mobilePreview = null;

  if (isMobile) {
    text = <Layout.Text>Double-check each design, and edit any photo you&#39;d like.</Layout.Text>;
    tips = null;
    photoActions = (
      <div
        className={styles.photoActions}
        style={{ visibility: enablePhotoUpload ? 'visible' : 'hidden' }}
      >
        <MultiSample.UploadButton
          icon={<i className="zolaicon zolaicon-upload-file" />}
          templatePage={template && template.pages[0]}
          customizations={form.customizations}
          updateForm={updateForm}
          multiPreviewState={multiPreviewState}
          setMultiPreviewState={setMultiPreviewState}
          isMobile={isMobile}
        />
        <MultiSample.CropButton
          icon={<i className="zolaicon zolaicon-pencil" />}
          templatePage={template && template.pages[0]}
          updateForm={updateForm}
          multiPreviewState={multiPreviewState}
          setMultiPreviewState={setMultiPreviewState}
          isMobile={isMobile}
        />
      </div>
    );
    mobilePreview = React.cloneElement(previewElement, { hideColorPicker: true });
  }

  return (
    <Layout.Box>
      <Layout.Row>
        <Layout.PreviewBox>{previewElement}</Layout.PreviewBox>
        <Layout.Col>
          <BreadCrumbs.Text step={step} breadcrumbSteps={breadcrumbSteps} />
          <Layout.Header>Review Your Photos</Layout.Header>
          {text}
          {tips}
          {mobilePreview}
          {photoActions}
          <Layout.FormButtons
            backLabel="Back"
            nextLabel="Next"
            backDisabled={breadcrumbSteps.findIndex(k => k === step.key) === 0}
            onBack={() => goToStep(isPhotoValid ? STEPS.PHOTO_CROP : STEPS.FILE_UPLOAD)}
            onNext={() => {
              if (
                (isMulti && multiHasCustomizableCard) ||
                (FeatureFlags.get('invitesSingleSampleCustomizeStep') && !sampleNotCustomizable)
              ) {
                goToStep(STEPS.CUSTOMIZATION);
              } else {
                goToStep(STEPS.WEDDING_DETAILS_FORM);
              }
            }}
          />
        </Layout.Col>
      </Layout.Row>
      <BreadCrumbs.Dots step={step} breadcrumbSteps={breadcrumbSteps} />
    </Layout.Box>
  );
};

export default MultiUploadHelp;



// WEBPACK FOOTER //
// ./src/cards/components/common/SingleSample/SingleSampleFlowSteps/MultiUploadHelp.jsx